var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoEn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1031.33 283.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#1d1d1b;}.cls-1{fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M80.12,247.73c12,0,24.18.47,36.2.73,9.69.2,28,2.35,28.64-8,.35-5.45-3.87-8.95-2.57-15.43,1.38-6.87,17.33-13.84,4.8-22.82-4.32-3.1-8.89-3.88-6.62-11.11,6.89-3.44,16.74,4.85,18.64-7.44,1.42-9.2-7.51-14.84-2.49-20.56,4.5-5.12,20.81,3.06,17.69-10-1.58-6.58-24.47-31.89-30.6-40-3.05-4-3.12-3.83-2.52-10.44,2.92-32.66-9.07-59.13-34.22-77.17C84.38,9.21,48.52,2,19.76.14,11.5-.4,1.43.34.15,8.09c-1.35,8.15,6.9,14.59,10,18.74C18.39,37.94,25.6,43.38,30.68,61.91c4.31,15.71-1.81,46.53,14.75,69.52,9.88,13.7,25.17,7.11,24.47,18.17-.41,6.5-12.8,7.4-19.12,23.65-8.36,21.5,14.15,33,8.69,71.06-5.11,14.42-23.95,25.82-23.26,33,.32,3.42,4,6.25,8.19,6.14,4.83-.12,7.54-3.11,9.51-5.51a195.36,195.36,0,0,1,13-14.9l13.26-15.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M280.92,247.71a44.67,44.67,0,0,0,6.55,8l19.68,22c8.36,10.36,17.31,4.29,17.6-.45-2.38-6-15.6-20-19.29-23.25-6.7-5.82-5-28.14-3.46-36.26,3-15.28,14.74-28.93,7.91-45.12-6.56-15.54-19-16.52-18.85-23.87.08-4.41,3.37-6,7-7,9.72-2.58,13.37-4.81,17.75-10.89,15.31-21.21,9.11-50.22,14.65-69.63,9.27-32.48,33.7-40.23,30.16-53.93C358.78.14,348.76-.37,340.49.19c-44.77,3-92.29,15.51-112.91,55.43-6.71,13-9.44,31.11-7.75,47.88.94,9.35-3.43,9.52-9.61,18.26-5.15,7.27-22.77,24.87-24,32.4-1.84,11.59,14,4.46,18,8.88,5.13,5.61-3.95,11.34-2.5,20.58,2.1,13.29,14.95,3.2,18.62,7.49,2.3,7-2.26,8.11-6.64,11.1-12.49,8.55,3.4,15.93,4.82,22.83,1.35,6.6-2.92,10.31-2.63,15.44.56,10.29,19.08,8.19,28.62,8,12-.27,24.28-.69,36.35-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M489.69,129.73H467.08v45.21H434V35.36h60.21c29.42,0,48.91,18.88,48.91,47.19,0,18.28-8.19,32.63-21.83,40.49l24.94,51.9H509.37ZM467.08,98.27h24C501.77,98.27,509,92,509,82.55s-7.21-15.73-17.93-15.73h-24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M649.08,153.71H596.47l-6.82,21.23H554.58L603.29,35.36h39L691,174.94H655.9Zm-9.55-29.49L622.77,71.73,606,124.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M860.11,35.36V174.94H827V87.46l-29.22,87.48H767.94L739.3,89.23v85.71H706.17V35.36h44.24l32.73,97.51,32.74-97.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M969.82,153.71H917.21l-6.82,21.23H875.31L924,35.36h39l48.71,139.58H976.64Zm-9.55-29.49L943.51,71.73l-16.76,52.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M433.72,204.52h10.17v42.86H433.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M488.16,204.52v42.86h-12l-14.36-27.11v27.11H451.67V204.52h12L478,231.62v-27.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M528.85,214.18H516.28v33.2H506.11v-33.2H493.55v-9.66h35.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M564,237.72v9.66H534.23V204.52h29.14v9.66h-19v7.24h16v9.06h-16v7.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M587.06,233.49h-6.94v13.89H570V204.52h18.49c9,0,15,5.79,15,14.49,0,5.61-2.51,10-6.7,12.43l7.66,15.94H593.1Zm-6.94-9.65h7.36c3.29,0,5.5-1.94,5.5-4.83s-2.21-4.83-5.5-4.83h-7.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M647.19,204.52v42.86h-12l-14.36-27.11v27.11H610.69V204.52h12L637,231.62v-27.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M680.87,240.86H664.72l-2.09,6.52H651.86l14.95-42.86h12l15,42.86H683Zm-2.93-9.06-5.14-16.11-5.15,16.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M725,214.18H712.46v33.2H702.29v-33.2H689.73v-9.66H725Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M730.41,204.52h10.17v42.86H730.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M746.57,226c0-13.28,8.67-22.16,21.66-22.16s21.65,8.88,21.65,22.22-8.67,22.09-21.65,22.09S746.57,239.23,746.57,226Zm32.54.06c0-7.37-4.36-12.26-10.88-12.26s-10.89,4.89-10.89,12.2,4.36,12.19,10.89,12.19S779.11,233.31,779.11,226Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M832.36,204.52v42.86h-12L806,220.27v27.11H795.87V204.52h12l14.36,27.1v-27.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M866.05,240.86H849.89l-2.09,6.52H837l15-42.86h12l15,42.86H868.14Zm-2.93-9.06L858,215.69l-5.14,16.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M910.92,237.72v9.66H883.58V204.52h10.17v33.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M930.1,226c0-13.28,8.49-22.16,21.12-22.16,10.23,0,17.77,5.8,19.44,14l-9.27,3.38a10,10,0,0,0-9.93-7.37c-6.23,0-10.59,4.89-10.59,12.2s4.36,12.19,10.59,12.19a10,10,0,0,0,9.93-7.36l9.27,3.38c-1.67,8.15-9.21,13.94-19.44,13.94C938.59,248.1,930.1,239.23,930.1,226Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M974.25,226c0-13.28,8.68-22.16,21.66-22.16s21.66,8.88,21.66,22.22-8.68,22.09-21.66,22.09S974.25,239.23,974.25,226Zm32.55.06c0-7.37-4.37-12.26-10.89-12.26S985,218.64,985,226s4.37,12.19,10.89,12.19S1006.8,233.31,1006.8,226Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1031.33,237.12v10.26h-10.17V237.12Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoEn);
export default __webpack_public_path__ + "static/media/logo_en.c7c992f93e4c7af00a6ce8c5eea124f3.svg";
export { ForwardRef as ReactComponent };